import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconArrowLeft: OSKIconDefinition = {
  name: 'arrow-left',
  content: '<path d="m12 19-7-7 7-7" /><path d="M19 12H5" />'
};
